import classes from "./AboutBook.module.css"

const AboutBook = ({title,author,language,publicationDate,desc,sku,isbnNo,pages,genres}) => {
    return(
        <div className={classes.container}>
            <div className={classes.detailContainer}>
                {title && <div className={classes.details}>
                    <h2>Book title</h2>
                    <p>{title}</p>
                </div>}
                {author && <div className={classes.details}>
                    <h2>Author</h2>
                    <p>{author}</p>
                </div>}
                {language && <div className={classes.details}>
                    <h2>Language</h2>
                    <p>{language}</p>
                </div>}
                {pages && <div className={classes.details}>
                    <h2>Total Pages</h2>
                    <p>{pages}</p>
                </div>}
                {Boolean(publicationDate) && <div className={classes.details}>
                    <h2>Publishing Year</h2>
                    <p>{publicationDate}</p>
                </div>}
                {sku && <div className={classes.details}>
                    <h2>SKU</h2>
                    <p>{sku}</p>
                </div>}
                {isbnNo && <div className={classes.details}>
                    <h2>ISBN No.</h2>
                    <p>{isbnNo}</p>
                </div>}
                {genres && genres.length > 0 && (
                    <div className={classes.details}>
                        <h2>Genre</h2>
                        <p>{genres.join(", ")}</p>
                    </div>
                )}
            </div>

            {desc && <div className={classes.description}>
                <h2 className={classes.descTitle}>Description</h2>
                <div className={"ql-editor"} dangerouslySetInnerHTML={{__html:desc}} style={{marginTop:"0.5rem",letterSpacing:"0.5px"}} />
            </div>}
        </div>
    )
}

export default AboutBook